namespace Gamification.Administration {
    export enum TwoFactorAuthType {
        Email = 1,
        SMS = 2
    }
    Serenity.Decorators.registerEnumType(TwoFactorAuthType, 'Gamification.Administration.TwoFactorAuthType');
}
